import React from 'react';
import { useLocation } from 'react-router-dom';
import { getOrgTermsContent } from '../../../../content/utils.js';
import PageHeader from '../../PageHeader.js';
import ReportsTabs from '../../../reports/ReportsTabs.jsx';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import { getReportType } from '../../../../helpers/breadcrumbRouteHelpers.js';

const ReportsHeader = ({ slug }) => {
  const location = useLocation();
  const reportType = getReportType(location.pathname);

  return (
    <PageHeader flexJustify navigation={<ReportsTabs slug={slug} />}>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <span>Reports</span>
        {reportType === 'project-reports' && (
          <span>{getOrgTermsContent('projectReports')}</span>
        )}
        {reportType === 'change-impact-reports' && (
          <span>Change Impact Reports</span>
        )}
      </BreadCrumbs>
    </PageHeader>
  );
};

export default ReportsHeader;
